function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arch_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "arch"
}, /*#__PURE__*/React.createElement("path", {
  className: "arch_fill",
  d: "M33.87,15.78c7.06,1.22,12.43,7.36,12.43,14.76v30h10V5.54L61.3,.54H1.3L6.3,5.54V60.54h10V30.54c0-7.41,5.38-13.55,12.43-14.77l.4,2.27h4.34l.4-2.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "arch_stroke",
  d: "M26.93,5.54l1.8,10.23c-7.06,1.22-12.43,7.36-12.43,14.77v30H6.3V5.54H26.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "arch_stroke",
  d: "M35.68,5.54l-1.8,10.24c7.06,1.22,12.43,7.36,12.43,14.76v30h10V5.54h-20.63Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "arch_stroke",
  points: "33.47 18.04 29.14 18.04 26.49 3.04 36.12 3.04 33.47 18.04"
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_stroke",
  x1: 4.3,
  y1: 60.54,
  x2: 18.3,
  y2: 60.54
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_stroke",
  x1: 44.3,
  y1: 60.54,
  x2: 58.3,
  y2: 60.54
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_stroke",
  x1: 4.3,
  y1: 30.54,
  x2: 18.3,
  y2: 30.54
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_stroke",
  x1: 44.3,
  y1: 30.54,
  x2: 58.3,
  y2: 30.54
}), /*#__PURE__*/React.createElement("polyline", {
  className: "arch_stroke",
  points: "6.3 5.54 1.3 .54 61.3 .54 56.3 5.54"
}));

var SvgArch = function SvgArch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "archIcon",
    viewBox: "-2 -2 66.61 65.08",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arch.2edc3c48.svg";
export { ForwardRef as ReactComponent };